/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_VERSION_SERVICE = '/checkout/v2';
const RESOURCE_PAGE_SERVICE = '/cart/subcart/scheduling';

/**
 * @param {*} params have the shipping method id need be search
 * @return Object with the delivery date and time for shipping method id
 */
const getExternalCartDTW = (jwtToken, deliveryMethodId) => {
    const envObj = {};
    const params = {
        deliveryMethodId,
    };

    envObj.rootUri = RESOURCE_VERSION_SERVICE;
    return restClient.getFacade(envObj, RESOURCE_PAGE_SERVICE, jwtToken, params)
        .then((response) => response);
};

export default getExternalCartDTW;
